import http from "./Endpoint";

/**
 * 
 */
class ProductService {

  /**
   * 
   * @param {*} params - {
   *   quantity: ev.currentTarget.value,
   *   productId: product.id,
   *   userId: user.id
   * }
   * @returns 
   */
  getPrice(params) {
    return http().post("/productNew/getPrice", params );
  }
  
  /**
   * Query product information
   * @param {*} params - {
   *  productId: - Produc Id,
   *  userId: 1,
   *  include:  ["pick_fees", "quantity_list", "department_list", "inventories_logs", "actual_inventory", "price_ranges", "afis"]
   * @returns {*}
   */
  getById(data) {
    return http().post("/productNew/getById", data);
  }


  /**
   * Get product categories for a user
   * @param {*} params - {
   *  customerId:
   *  userId:
   * }
   * @param [] includes  - specify additinal data return
   * @returns 
   */
  category(params) {
    return http().post("/productNew/categories", {
      "filter": { customer_id: params.customerId, user_id: params.userId },
      "return": params.include
    });
  }

  /**
   * Get a list of products
   * @params {*} params - {
   *  customerId: 1,
   *  userId: 1,
   *  categoryId: 1,
   *  include: []
   * }
   * @returns 
   */
  query(params) {
    return http().post("/productNew/query", params);
  }

  /**
   * Move destroy product to cart
   * @param int productId, userId, customerId
   * @param string option - "ADD2CART"
   * @returns 
   */
  destroy(productId, userId, customerId, option) {
    const article = {
      id: productId,
      user_id: userId,
      customer_id: customerId,
      option: option
    }
    return http().post("/product/destroy", article);
  }

  /**
   * Deactivate a product
   * @param int  productId, customerId
   * @returns 
   */
  delete(productId, customerId) {
    const article = {
      id: productId,
      customer_id: customerId
    };
    return http().post("/product/delete", article);
  }

  /**
   * Update product Info
   * @param int productId 
   * @param {*} data - field and value pare to be update 
   * @returns 
   */
  update(productId, data) {
    return http().post("/product/update", data);
  }

  /**
   * Update Afis for customizable product
   * @param {*} prodcustId 
   * @param {*} customerId 
   * @param {*} afis 
   */
  updateAfis(productId, customerId, afis) {
    const article = {
      product_id: productId,
      customer_id: customerId,
      afis: afis
    };
    return http().post("/product/updateAfis", article);
  }

  /**
   * Get list of product types
   * @returns 
   */
  types() {
    let article = {
      "category": "quickbook_types"
    }
    return http().post("/product/enum", article);
  }

}

export default new ProductService();